import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import Form from '../../components/auth/updateProfile'
import { v3_update_profile } from '../../actions/v3/user'
import { toast } from 'react-toastify'
import { v3_userProfile } from '../../actions/v3/user'
const Add = (props) => {


    const [userData, setUserData] = useState(null)

    useEffect(() => {
        v3_userProfile().then((res) => {
            if (res.status) {
                setUserData(res.result)
            }
        })
    }, [])
    const onSubmit = (model) => {
        v3_update_profile(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
            }
            else {
                toast.error(res.error)
            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Update Profile'}>
                {userData && <Form
                    title={'Update Profile'}
                    onSubmit={onSubmit}
                    data={userData}
                    buttonName={'Save'}

                />}
            </Layout>

        </React.Fragment>
    )
}

export default Add